// hooks
import { useWindowModel } from '../../hooks';
// components
import { PoliticsFooter as normal } from './PoliticsFooter.normal';
// import { PoliticsFooter as mini } from './PoliticsFooter.mini';
// import { PoliticsFooter as pad } from './PoliticsFooter.pad';
// import { PoliticsFooter as phone } from './PoliticsFooter.phone';
// model
import { WindowModelType } from '../../models';
import { ReactElement } from 'react';
// import { PoliticsFooter } from './PoliticsFooter.normal';

const NavDispatcher: {[key in WindowModelType]: ReactElement} = {
    mini: normal(),
    normal: normal(),
    pad: normal(),
    phone: normal(),
};

export const PoliticsFooter = () => {
    const windowModel = useWindowModel();
    return NavDispatcher[windowModel];
};



// WEBPACK FOOTER //
// ./src/components/PoliticsFooter/index.ts